import { useIntl } from 'react-intl';
import { StyledSelect } from 'styles/overrides';
import _ from 'lodash';
import { useWards } from 'api/locationApi';
import { filterOptions } from 'utils/formatUtils';

export default function WardSelector({
  provinceId,
  districtId,
  onChange,
  value,
  ...restProps
}) {
  const intl = useIntl();
  const { data = [], isLoading } = useWards({
    provinceId,
    districtId,
    options: {
      select: (response) =>
        _.map(response, ({ id, name, prefix }) => ({
          label: `${prefix} ${name}`,
          value: id.toString(),
        })),
    },
  });

  return (
    <StyledSelect
      options={data}
      placeholder={intl.formatMessage({ id: 'common.placeholder.ward' })}
      loading={isLoading}
      {...restProps}
      showSearch
      optionFilterProp="label"
      filterOption={filterOptions}
      onChange={onChange}
      value={value}
    />
  );
}
